__webpack_require__.p = "/placeholder-typeahead/onboarding/";